module.exports = __webpack_public_path__ + "img/BRCA1_TMKI67.3425b322.png";